<template>
  <div class="ExcelMemento">
    <v-menu :close-on-content-click="false" min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="neumorphism-out-animated" v-bind="attrs" v-on="on">
          <v-icon color="green"> mdi-microsoft-excel </v-icon>
        </v-btn>
        <span>{{ $t("memento.export") }}</span>
      </template>

      <v-card v-click-outside="closeDialog">
        <v-date-picker
          :locale="this.$i18n.locale"
          :min="datesList[0]"
          :max="datesList[1]"
          color="green darken-2"
          v-model="datesList"
          range
        ></v-date-picker>
        <v-card-text>
          <span>{{ $t("memento.interval") }}</span>
          <br />
          <span>
            {{
              `${datesList[0] ? datesList[0] : $t("memento.toSelect")} ~ ${
                datesList[1] ? datesList[1] : $t("memento.toSelect")
              }`
            }}
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="!datesList[1]"
            text
            color="green darken-2"
            @click="downloadCSV"
          >
            <span>{{ $t("memento.exportCsv") }}</span>
          </v-btn>
        </v-card-actions>
        <v-card-text class="errors" v-if="showErrorMessage">
          {{ errorMessage }}
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Range from "@/models/range";
import { downloadMementoHtpp } from "@/services/planning/MementoService.js";

export default {
  props: [],
  components: {},
  data() {
    return {
      today: new Date().toISOString().substr(0, 10),
      datesList: [],
      showErrorMessage: false,
      errorMessage: "",
    };
  },
  mounted() {},
  methods: {
    /**
     * Download a CSV for events historic (InterventionMemento).
     */
    downloadCSV() {
      let range = new Range(this.datesList);
      this.showErrorMessage = false;
      this.errorMessage = "";
      downloadMementoHtpp(range.start, range.end)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "interventionsModification.csv");
          document.body.appendChild(link);
          link.click();
          this.closeDialog();
        })
        .catch((error) => {
          this.showErrorMessage = true;
          this.errorMessage = this.$t("errorFrontEnd.downloadProblem");
        });
    },
    closeDialog() {
      this.showErrorMessage = false;
      this.errorMessage = "";
      this.datesList = [];
    },
  },
};
</script>

<style lang="scss">
.ExcelMemento {
  padding: 0 10px 0 0;
  border-radius: 50px;

  button {
    margin: 0 10px 0 0;
  }
}

.errors {
  width: 290px;
  word-wrap: break-word;
  margin: 0;
  color: red !important;
}
</style>
